import React from 'react';
import styled from '@emotion/styled';
import { TableCell } from '@mui/material';
import Table from '@mui/material/Table';
import Anchor from './Anchor';

export { default as TableContainer } from '@mui/material/TableContainer';
export { default as TableBody } from '@mui/material/TableBody';
export { default as TableCell } from '@mui/material/TableCell';
export { default as TableHead } from '@mui/material/TableHead';
export { default as TableRow } from '@mui/material/TableRow';

export const TableCellWithMonoSpaceFonts = styled(TableCell)`
  font-family: 'ui-monospace', 'SFMono-Regular', 'Menlo', 'Monaco', 'Consolas';
`;

interface SocialMediaValueCellProperties {
  value: number;
  alignRight?: boolean;
}

export const SocialMediaValueCell = ({
  value,
  alignRight,
}: SocialMediaValueCellProperties) => (
  <TableCellWithMonoSpaceFonts
    width="20%"
    align={alignRight ? 'right' : 'left'}
  >
    {new Intl.NumberFormat('en-US').format(value)}
  </TableCellWithMonoSpaceFonts>
);

interface SocialMediaTableCellsProperties {
  index: number;
  link: string;
  value: string;
}

export const SocialMediaTableCells = ({
  index,
  link,
  value,
}: SocialMediaTableCellsProperties) => (
  <>
    <TableCell width="10%">
      {index}
    </TableCell>
    <TableCell width="70%">
      <Anchor
        href={link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {value}
      </Anchor>
    </TableCell>
  </>
);

const StyledTable = styled(Table)`
  table-layout: fixed;
`;

export default StyledTable;
